//Gustavo Rodrigues 

//Ave Maria Cheia de Graça o Senhor é convosco, bendita sois vós entre as mulheres e bendito é o fruto do vosso ventre, Jesus.
//Santa Maria Mãe de Deus, rogai por nós pecadores, agora e na hora de nossa morte. Amém.

//JESUS EU CONFIO EM VÓS! MARIA, MÃE DA DIVINA GRAÇA, ROGAI POR NÓS! 
//EM NOME DO PAI, DO FILHO E DO ESPÍRITO SANTO. AMÉM!


import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import 'bootstrap/dist/css/bootstrap.min.css'; // Importa os estilos do Bootstrap
import 'bootstrap'; // Importa os scripts do Bootstrap
import 'bootstrap-icons/font/bootstrap-icons.css';
import VueAwesomePaginate from "vue-awesome-paginate";
import 'select2';
import 'select2/dist/css/select2.css'
import 'select2-theme-bootstrap4/dist/select2-bootstrap.css'

// import the necessary css file

import "vue-awesome-paginate/dist/style.css";


import $ from 'jquery';

// import { MaskInput } from 'vue-3-mask';
import money from 'v-money3'

import LoadingPlugin from './plugins/loading'
import GlobalLoading from './components/GlobalLoading.vue'


// Corrige o erro do ResizeObserver do ECharts
const resizeObserverErr = () => {};
window.addEventListener('error', e => {
  if (e.message === 'ResizeObserver loop completed with undelivered notifications.') {
    e.stopImmediatePropagation();
  }
});
window.addEventListener('unhandledrejection', resizeObserverErr);


window.$ = $;
createApp(App)
.use(store)
.use(router)
.use(VueAwesomePaginate)
.use(money)
.use(LoadingPlugin)
// .component('MaskInput', MaskInput)
.component('GlobalLoading', GlobalLoading)

.mount('#app')
